import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

/** Host-provided gate deciding which custom object types render the workspace shell. */
export interface ObjectWorkspaceConfig {
  /**
   * Whether the workspace shell should render for this custom object type on the given partner.
   * Async and partner-aware: an implementation may consult a per-partner feature flag, and the
   * shell re-evaluates when the active partner (PID) changes.
   */
  isWorkspaceEnabled(customObjectTypeId: string, partnerId: string): Observable<boolean>;
}

/**
 * Build a config from a static set of enabled custom object type IDs (partner-agnostic). Hosts that
 * need partner gating provide their own `ObjectWorkspaceConfig` (e.g. one backed by a per-partner
 * feature flag).
 */
export function createObjectWorkspaceConfig(enabledTypeIds: string[]): ObjectWorkspaceConfig {
  const enabled = new Set(enabledTypeIds);
  return {
    isWorkspaceEnabled: (customObjectTypeId) => of(enabled.has(customObjectTypeId)),
  };
}

/** Defaults to an empty registry, so the shell stays transparent until a host registers a type. */
export const CRM_OBJECT_WORKSPACE_CONFIG = new InjectionToken<ObjectWorkspaceConfig>('CrmObjectWorkspaceConfig', {
  providedIn: 'root',
  factory: () => createObjectWorkspaceConfig([]),
});
